import { toast } from 'sonner';

// Capture a DOM element as PNG: copy to clipboard, fallback to download.
export const captureElement = async (el, filename) => {
  if (!el) return;

  el.setAttribute('data-capture-target', 'active');
  const scrollers = [el, ...el.querySelectorAll('*')].filter((node) => {
    const s = window.getComputedStyle(node);
    return /(auto|scroll)/.test(s.overflowX) || /(auto|scroll)/.test(s.overflow);
  });
  const savedStyles = scrollers.map((node) => ({ node, cssText: node.style.cssText }));
  scrollers.forEach((node) => {
    node.style.overflow = 'visible';
    node.style.overflowX = 'visible';
    node.style.maxWidth = 'none';
    node.style.width = `${node.scrollWidth}px`;
  });
  void el.offsetWidth;
  const fullWidth = Math.max(el.scrollWidth, el.offsetWidth);

  const restoreStyles = () => {
    savedStyles.forEach(({ node, cssText }) => { node.style.cssText = cssText; });
    el.removeAttribute('data-capture-target');
  };

  try {
    const { toBlob } = await import('html-to-image');
    const blob = await toBlob(el, {
      pixelRatio: 2,
      backgroundColor: '#ffffff',
      cacheBust: true,
      width: fullWidth,
      height: el.scrollHeight,
      style: { transform: 'none' },
    });
    restoreStyles();

    if (!blob) {
      toast.error('Gagal membuat gambar');
      return;
    }

    if (navigator.clipboard && window.ClipboardItem) {
      try {
        await navigator.clipboard.write([new window.ClipboardItem({ 'image/png': blob })]);
        toast.success('Gambar berhasil disalin ke clipboard!');
        return;
      } catch (err) {
        console.error('Error copying to clipboard:', err);
      }
    }

    const url = URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${filename}.png`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
    toast.success('Gambar berhasil diunduh!');
  } catch (error) {
    restoreStyles();
    console.error('Error capturing screenshot:', error);
    toast.error('Gagal menangkap screenshot');
  }
};
